import { render, staticRenderFns } from "./PointCard.vue?vue&type=template&id=11ea2a70&scoped=true&"
import script from "./PointCard.vue?vue&type=script&lang=js&"
export * from "./PointCard.vue?vue&type=script&lang=js&"
import style0 from "./PointCard.vue?vue&type=style&index=0&id=11ea2a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ea2a70",
  null
  
)

export default component.exports